<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  validations: {
    invalidCheck: {},

    form: [],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">ملاحظات</h5></div>

      <div class="col-md-12">
        <ul class="notes">
          <li>
            <p>سنقوم بالإتصال بكم بأقرب وقت ممكن من اجل اجراء المقابلة .</p>
          </li>
          <li>
            <p>سنطلب المستمسكات الثبوتية ايضاً لغرض اكمال المعلومات .</p>
          </li>
          <li>
            <p>رقم الهاتف : 07772225487</p>
          </li>
          <li>
            <p>البريد الالكتروني الرسمي : volunteer.work.center@gmail.com</p>
          </li>
          <li>
            <p>حساب تلكرام : @V_work_BOT</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
